import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';

import store from '../../store';

@customElement('family-overview')
export class FamilyOverview extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				width: 100%;
				margin: 0;
			}

			.familyDescription {
				container-type: inline-size;
			}
			.shortDescription {
				container-type: inline-size;
			}

			.familyDescription p {
				font: var(--font-specsheet-print-headline);
				margin-top: 0;
				margin-bottom: 0;
				font-size: 2.7cqw;
			}

			.shortDescription p {
				font: var(--font-specsheet-print-small-text);
				font-size: 2.7cqw;
			}

			.imageSection {
				max-width: 100%;
				height: 100%;
				margin-top: 1cqw;
				line-height: 0;
			}

			.fullImage {
				width: 100%;
				margin-top: 2cqw;
				height: auto;
				object-fit: cover;

			}

			.imagesContainer {
				margin-top: 1cqw;
				display: grid;
				grid-template-columns: repeat(2, 1fr);
				grid-template-rows: 1fr;
				grid-column-gap: 1cqw;
				grid-row-gap: 0;


			}
			.img {
				width: 100%;
				height: auto;
				object-fit: cover;
			}

			.shortDescription {
				line-height: 1.4;
				width: 50%;
				margin-top: 2cqw;
			}

		`]
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		if (state.specsheet.data.specsheets && state.status?.productFamily) {
			this.kirbySpecsheets = state.specsheet.data.specsheets;
			this.family = state.status.productFamily;
			this.kirbySpecsheet = this.kirbySpecsheets.find(specsheet => specsheet.id === this.family);
		}
	}

	render() {
		if (!this.kirbySpecsheet) return html``;

		return html`
			<div class="familyOverview">
				<section class="familyDescription">
					<p>${this.kirbySpecsheet.family_intro}</p>
				</section>

				<section class="imageSection">
					${when(this.kirbySpecsheet.cover_image_big, () => html`
						<img class="fullImage" src=${this.kirbySpecsheet.cover_image_big}/>
					`, () => html``)}
					<div class="imagesContainer">
						${when(this.kirbySpecsheet.cover_image_left, () => html`
							<img class="img" src=${this.kirbySpecsheet.cover_image_left}/>
						`, () => html``)}
						${when(this.kirbySpecsheet.cover_image_right, () => html`
							<img class="img" src=${this.kirbySpecsheet.cover_image_right}/>
						`, () => html``)}
					</div>
				</section>

				<section class="shortDescription">
					<p>${this.kirbySpecsheet.family_description}</p>
				</section>

			</div>
		`;
	}
}
